export enum recruitmentsDetailTypes {
  FETCH_RECRUIMENTS_DETAIL_REQUEST = "FETCH_RECRUIMENTS_DETAIL_REQUEST",
  FETCH_RECRUIMENTS_DETAIL_SUCCESS = "FETCH_RECRUIMENTS_DETAIL_SUCCESS",
  FETCH_RECRUIMENTS_DETAIL_FAILURE = "FETCH_RECRUIMENTS_DETAIL_FAILURE",
}